import { CatalogGroup } from "../interfaces/catalog.interface";

export const allCatalogs: CatalogGroup[] = [
  "academies",
  "schools",
  "factor",
  "grupo",
  "competencias",
  "region",
  "sede",
  "area",
  "subArea",
  "organization",
  "country",
  "tipoCurso",
  "tipoAsistencia",
  "tipoSesion",
  //"tipoCapacitacion",
  "justification",
];

export const calendarCatalogs = [
  "tipoAsistencia",
  "tipoSesion",
  "tipoCapacitacion",
];

export const catalogsWithDescription = [
  ...calendarCatalogs,
  "schools",
  "competencias",
  "tipoCurso",
  "region",
  "sede",
];

export const catalogHierarchy: Partial<Record<CatalogGroup, CatalogGroup[]>> = {
  academies: ["schools"],
  factor: ["grupo"],
  grupo: ["competencias"],
  region: ["sede"],
  area: ["subArea"],
};
